import { makeStyles, Paper, Container, Typography, Theme } from '@material-ui/core';
import React, { FC } from 'react';

export interface ErrorBlockProps {
  name: string;
  message: string;
  error?: Error;
}

var useStyles = makeStyles(function (theme: Theme) {
  return {
    errorContainer: {
      margin: theme.spacing(2),
      padding: theme.spacing(1, 3, 2)
    }
  };
});

export const ErrorBlock: FC<ErrorBlockProps> = function (props) {
  const classes = useStyles({});

  return (
    <Container maxWidth = { 'md' }>
      <Paper className = { classes.errorContainer }>
        <Typography variant = { 'h6' }>
          { props.name }
        </Typography>
        <Typography variant = { 'body1' }>
          { props.message }
        </Typography>
          {
            props.error &&
              <Typography variant = { 'caption' } color = { 'error' }>
                { props.error.name }: { props.error.message }
              </Typography>
          }
      </Paper>
    </Container>
  )
};
